import { call, put, takeLatest } from "redux-saga/effects";
import {
  doLoadingStart,
  doLoadingFinish,
} from "Components/Common/ProgressIndicator/Actions/ProgressIndicatorActions";

import * as actionTypes from "Redux/Actions/actionTypes";
import GetApplicationNotes from "../../Communication/ApiClasses/GetApplicationNotes";
import {
  getApplicationNotesSuccess,
  getApplicationNotesError,
} from "../Actions/ApplicationNotesAction";

// worker
function* handleGetApplicationNotes(action) {
  console.log(
    "GetApplicationNotesSaga - handleGetApplicationNotes started with action:",
    action
  );
  yield put(
    doLoadingStart(`${actionTypes.GET_APPLICATION_NOTES_REQUEST}_SAGA`)
  );
  const getApplicationNotesApi = new GetApplicationNotes(action.applicationId);
  try {
    console.log(
      "GetApplicationNotesSaga - Calling API with applicationId:",
      action.applicationId
    );
    const result = yield call(getApplicationNotesApi.getData);
    console.log("GetApplicationNotesSaga - API call success, result:", result);
    yield put(getApplicationNotesSuccess(result.data || result));
    yield call(action.callback, result);
  } catch (error) {
    console.error("GetApplicationNotesSaga - API call error:", error);
    yield put(getApplicationNotesError(error.response?.data || error.message));
    yield call(action.callback, error.response);
  } finally {
    yield put(
      doLoadingFinish(`${actionTypes.GET_APPLICATION_NOTES_REQUEST}_SAGA`)
    );
  }
}

// watcher
export default function* getApplicationNotesWatcherSaga() {
  yield takeLatest(
    actionTypes.GET_APPLICATION_NOTES_REQUEST,
    handleGetApplicationNotes
  );
}
